// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Multiplayer Styles */

.multiplayer-lobby {
  max-width: 900px;
  margin: 20px auto;
  padding: 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.2);
  color: white;
}

.multiplayer-lobby h2 {
  text-align: center;
  margin-bottom: 30px;
  font-size: 28px;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.3);
}

/* Tabs */
.tabs {
  display: flex;
  gap: 10px;
  margin-bottom: 30px;
  justify-content: center;
  flex-wrap: wrap;
}

.tab {
  padding: 12px 24px;
  background: rgba(255,255,255,0.2);
  border: 2px solid transparent;
  border-radius: 8px;
  color: white;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 15px;
}

.tab:hover {
  background: rgba(255,255,255,0.3);
  transform: translateY(-2px);
}

.tab.active {
  background: rgba(255,255,255,0.9);
  color: #667eea;
  border-color: white;
}

/* Messages */
.message {
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 20px;
  text-align: center;
  font-weight: 500;
}

.message.success {
  background: rgba(52, 211, 153, 0.2);
  color: #34d399;
  border-left: 4px solid #34d399;
}

.message.error {
  background: rgba(239, 68, 68, 0.2);
  color: #fca5a5;
  border-left: 4px solid #ef4444;
}

/* Create Form */
.create-form {
  background: rgba(255,255,255,0.1);
  padding: 25px;
  border-radius: 12px;
  backdrop-filter: blur(10px);
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  font-size: 15px;
}

.form-group select,
.form-group input {
  width: 100%;
  padding: 12px;
  border: 2px solid rgba(255,255,255,0.3);
  border-radius: 8px;
  background: rgba(255,255,255,0.95);
  color: #333;
  font-size: 14px;
  transition: border-color 0.3s ease;
}

.form-group select:focus,
.form-group input:focus {
  outline: none;
  border-color: rgba(255,255,255,0.8);
  background: white;
}

.form-group small {
  display: block;
  margin-top: 5px;
  font-size: 12px;
  opacity: 0.8;
}

/* Buttons */
.btn-primary,
.btn-secondary,
.btn-large {
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 15px;
}

.btn-primary {
  background: linear-gradient(135deg, #34d399 0%, #10b981 100%);
  color: white;
  width: 100%;
  margin-top: 10px;
}

.btn-primary:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(52, 211, 153, 0.3);
}

.btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-secondary {
  background: rgba(255,255,255,0.2);
  color: white;
  width: 100%;
  margin-top: 10px;
}

.btn-secondary:hover:not(:disabled) {
  background: rgba(255,255,255,0.3);
  transform: translateY(-2px);
}

.btn-large {
  padding: 20px 40px;
  font-size: 18px;
  background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%);
  color: #333;
  width: 100%;
  margin: 20px 0;
}

.btn-large:hover:not(:disabled) {
  transform: scale(1.05);
  box-shadow: 0 10px 30px rgba(251, 191, 36, 0.3);
}

.lucky-action-btn {
  width: 50%;
  margin-left: auto;
  margin-right: auto;
}

.start-spotlight {
  display: grid;
  justify-items: center;
  gap: 8px;
  max-width: 300px;
  margin: 14px auto 8px;
  padding: 12px 14px;
  text-align: center;
  border-radius: 14px;
  border: 1px solid rgba(255,255,255,0.18);
  background: radial-gradient(circle at top, rgba(251,191,36,0.18), transparent 58%), rgba(255,255,255,0.10);
  box-shadow: 0 12px 24px rgba(0,0,0,0.18);
}

.start-spotlight__title {
  font-size: 15px;
  font-weight: 800;
}

.start-spotlight__sub {
  font-size: 12px;
  color: rgba(255,255,255,0.82);
}

.start-spotlight .btn-primary,
.start-spotlight .btn-large {
  width: auto;
  min-width: 170px;
  margin-top: 0;
  padding: 9px 16px;
  font-size: 14px;
  border-radius: 999px;
}

@media (max-width: 640px) {
  .start-spotlight {
    margin-top: 16px;
    padding: 10px 12px;
  }
}

/* Available Challenges */
.available-challenges {
  background: rgba(255,255,255,0.1);
  padding: 25px;
  border-radius: 12px;
  backdrop-filter: blur(10px);
}

.available-challenges h3 {
  margin-bottom: 20px;
  font-size: 18px;
}

.join-toolbar {
  display: grid;
  grid-template-columns: 1.2fr 0.7fr 0.7fr 1fr 1fr auto;
  gap: 10px;
  align-items: center;
  margin: 10px 0 16px;
}

.toolbar-input,
.toolbar-select {
  width: 100%;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid rgba(255,255,255,0.22);
  background: rgba(255,255,255,0.92);
  color: #222;
  font-size: 14px;
}

.toolbar-input:focus,
.toolbar-select:focus {
  outline: none;
  border-color: rgba(255,255,255,0.55);
  background: #fff;
}

@media (max-width: 760px) {
  .join-toolbar {
    grid-template-columns: 1fr 1fr;
  }
}

.challenges-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 15px;
}

/* Compact Join list (scales better than cards) */
.challenges-compact {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.challenge-row {
  display: grid;
  grid-template-columns: 1.2fr 0.8fr 0.8fr 1.2fr;
  gap: 10px;
  align-items: center;
  padding: 12px 12px;
  border-radius: 10px;
  background: rgba(0,0,0,0.25);
  border: 1px solid rgba(255,255,255,0.18);
}

.challenge-row.header {
  background: rgba(0,0,0,0.35);
  border-color: rgba(255,255,255,0.22);
  font-weight: 700;
  font-size: 13px;
}

.challenge-row .cell {
  font-size: 14px;
  color: rgba(255,255,255,0.95);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.challenge-row .cell.actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.btn-inline {
  width: auto;
  margin-top: 0;
  padding: 10px 14px;
  font-size: 14px;
}

/* Modal */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px;
  z-index: 9999;
}

.modal {
  width: min(520px, 95vw);
  background: linear-gradient(135deg, rgba(20,20,30,0.95) 0%, rgba(30,20,45,0.95) 100%);
  border: 1px solid rgba(255,255,255,0.18);
  border-radius: 14px;
  color: white;
  box-shadow: 0 20px 50px rgba(0,0,0,0.35);
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-bottom: 1px solid rgba(255,255,255,0.12);
}

.modal-header h3 {
  margin: 0;
  font-size: 18px;
}

.modal-close {
  background: transparent;
  border: none;
  color: rgba(255,255,255,0.9);
  font-size: 26px;
  line-height: 1;
  cursor: pointer;
}

.modal-body {
  padding: 14px 16px;
}

.modal-body p {
  margin: 8px 0;
  font-size: 14px;
  color: rgba(255,255,255,0.95);
}

.modal-footer {
  padding: 14px 16px;
  border-top: 1px solid rgba(255,255,255,0.12);
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

@media (max-width: 520px) {
  .challenge-row {
    grid-template-columns: 1fr 0.8fr 0.8fr;
    grid-template-areas:
      "creator wager players"
      "actions actions actions";
  }
  .challenge-row .cell.actions {
    justify-content: flex-start;
  }
}

.challenge-card {
  background: rgba(0,0,0,0.25);
  border: 2px solid rgba(255,255,255,0.25);
  border-radius: 10px;
  padding: 15px;
  transition: all 0.3s ease;
  cursor: pointer;
}

.challenge-card:hover {
  background: rgba(0,0,0,0.32);
  border-color: rgba(255,255,255,0.55);
  transform: translateY(-5px);
}

.challenge-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.challenge-header h4 {
  margin: 0;
  font-size: 16px;
  color: rgba(255, 255, 255, 0.98);
}

.badge {
  background: rgba(255,255,255,0.3);
  padding: 4px 8px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
}

.challenge-details p {
  margin: 8px 0;
  font-size: 14px;
  opacity: 1;
  color: rgba(255, 255, 255, 0.95);
}

.challenge-details strong {
  color: rgba(255, 255, 255, 1);
}

.challenge-instructions {
  margin-top: 12px;
  padding: 10px 12px;
  background: rgba(0, 0, 0, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 10px;
}

.challenge-instructions .instruction-line {
  font-size: 13px;
  line-height: 1.3;
  opacity: 1;
  color: rgba(255, 255, 255, 0.98);
}

.challenge-instructions .instruction-line + .instruction-line {
  margin-top: 6px;
}

.challenge-instructions .instruction-hint {
  margin-top: 8px;
  font-size: 12px;
  line-height: 1.3;
  color: rgba(255, 255, 255, 0.9);
}

/* Multiplayer Game */
.multiplayer-game {
  max-width: 900px;
  margin: 20px auto;
  padding: 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.2);
  color: white;
  overflow-x: hidden;
}

.multiplayer-game h2,
.multiplayer-game h3 {
  text-align: center;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.3);
}

.waiting-state,
.rolling-state,
.results-state {
  background: rgba(255,255,255,0.1);
  padding: 25px;
  border-radius: 12px;
  backdrop-filter: blur(10px);
}

.player-list {
  margin: 20px 0;
  background: rgba(255,255,255,0.1);
  padding: 15px;
  border-radius: 8px;
}

.player-list h4 {
  margin: 0 0 10px 0;
  font-size: 15px;
}

.player-slot {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 0;
  border-bottom: 1px solid rgba(255,255,255,0.1);
}

.player-slot:last-child {
  border-bottom: none;
}

.player-badges {
  display: flex;
  align-items: center;
  gap: 6px;
}

.player-name {
  font-weight: 600;
}

.player-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid rgba(255,255,255,0.1);
}

.player-item:last-child {
  border-bottom: none;
}

.lucky-mode {
  font-weight: 700;
}

.lucky-mode.betting {
  color: #fca5a5;
}

.lucky-mode.friendly {
  color: #86efac;
}

.lucky-wager.betting {
  color: #fca5a5;
  font-weight: 900;
}

.lucky-wager.friendly {
  color: #86efac;
  font-weight: 900;
}

.dice-display {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin: 30px 0;
  flex-wrap: wrap;
}

.die {
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%);
  border-radius: 8px;
  font-size: 28px;
  font-weight: bold;
  color: #333;
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
}

.die.revealing {
  animation: die-reveal 0.7s ease-in-out;
}

@keyframes die-reveal {
  0% {
    transform: scale(0.8) rotate(-6deg);
    opacity: 0.4;
    filter: blur(2px);
  }
  60% {
    transform: scale(1.05) rotate(4deg);
    opacity: 0.9;
    filter: blur(0);
  }
  100% {
    transform: scale(1) rotate(0deg);
    opacity: 1;
    filter: blur(0);
  }
}

.multiplayer-game canvas {
  max-width: 100%;
  height: auto;
  display: block;
}

.dice-result {
  text-align: center;
}

.dice-result h2 {
  color: #34d399;
  font-size: 32px;
  margin: 20px 0;
}

.scores-board {
  margin-top: 25px;
  background: rgba(255,255,255,0.1);
  padding: 15px;
  border-radius: 8px;
}

.scores-board h4 {
  margin: 0 0 15px 0;
  font-size: 15px;
}

.score-item {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid rgba(255,255,255,0.1);
}

.score-item:last-child {
  border-bottom: none;
}

.score-item .score {
  font-weight: 600;
  color: #fbbf24;
}

/* Results */
.leaderboard {
  margin: 30px 0;
  background: rgba(255,255,255,0.1);
  border-radius: 12px;
  overflow: hidden;
}

.placement {
  padding: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(255,255,255,0.1);
}

.placement:last-child {
  border-bottom: none;
}

.placement.rank-1 {
  background: rgba(251, 191, 36, 0.2);
  border-left: 4px solid #fbbf24;
}

.placement.rank-2 {
  background: rgba(192, 192, 192, 0.2);
  border-left: 4px solid #c0c0c0;
}

.placement.rank-3 {
  background: rgba(205, 127, 50, 0.2);
  border-left: 4px solid #cd7f32;
}

.placement.rank-4 {
  background: rgba(255,255,255,0.05);
  border-left: 4px solid rgba(255,255,255,0.3);
}

.rank {
  font-weight: 700;
  font-size: 18px;
  min-width: 50px;
}

.prize {
  font-weight: 600;
  color: #34d399;
  font-size: 18px;
}

.result-summary {
  text-align: center;
  padding: 20px;
  background: rgba(34, 197, 94, 0.1);
  border-radius: 8px;
  margin-top: 20px;
}

/* Responsive */
@media (max-width: 768px) {
  .multiplayer-lobby,
  .multiplayer-game {
    margin: 10px;
    padding: 15px;
  }

  .challenges-list {
    grid-template-columns: 1fr;
  }

  .dice-display {
    gap: 5px;
  }

  .die {
    width: 50px;
    height: 50px;
    font-size: 22px;
  }

  .tab {
    padding: 10px 16px;
    font-size: 13px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Multiplayer.css"],"names":[],"mappings":"AAAA,uBAAuB;;AAEvB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,6DAA6D;EAC7D,mBAAmB;EACnB,uCAAuC;EACvC,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,wCAAwC;AAC1C;;AAEA,SAAS;AACT;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,6BAA6B;EAC7B,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;EACjC,cAAc;EACd,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,8BAA8B;AAChC;;AAEA,gBAAgB;AAChB;EACE,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,uCAAuC;EACvC,kBAAkB;EAClB,kCAAkC;EAClC,WAAW;EACX,eAAe;EACf,kCAAkC;AACpC;;AAEA;;EAEE,aAAa;EACb,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA,YAAY;AACZ;;;EAGE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,6DAA6D;EAC7D,WAAW;EACX,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,+CAA+C;AACjD;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,wCAAwC;EACxC,0GAA0G;EAC1G,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,6BAA6B;AAC/B;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE;IACE,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA,yBAAyB;AACzB;EACE,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qDAAqD;EACrD,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,wCAAwC;EACxC,kCAAkC;EAClC,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8CAA8C;EAC9C,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;EAC5B,wCAAwC;AAC1C;;AAEA;EACE,4BAA4B;EAC5B,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,QAAQ;EACR,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,qFAAqF;EACrF,wCAAwC;EACxC,mBAAmB;EACnB,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE;IACE,sCAAsC;IACtC;;+BAE2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,4BAA4B;EAC5B,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,6DAA6D;EAC7D,mBAAmB;EACnB,uCAAuC;EACvC,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;;;EAGE,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE;IACE,mCAAmC;IACnC,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,mCAAmC;IACnC,YAAY;IACZ,eAAe;EACjB;EACA;IACE,gCAAgC;IAChC,UAAU;IACV,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,cAAc;EACd,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE;;IAEE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF","sourcesContent":["/* Multiplayer Styles */\n\n.multiplayer-lobby {\n  max-width: 900px;\n  margin: 20px auto;\n  padding: 20px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-radius: 15px;\n  box-shadow: 0 10px 30px rgba(0,0,0,0.2);\n  color: white;\n}\n\n.multiplayer-lobby h2 {\n  text-align: center;\n  margin-bottom: 30px;\n  font-size: 28px;\n  text-shadow: 2px 2px 4px rgba(0,0,0,0.3);\n}\n\n/* Tabs */\n.tabs {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 30px;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.tab {\n  padding: 12px 24px;\n  background: rgba(255,255,255,0.2);\n  border: 2px solid transparent;\n  border-radius: 8px;\n  color: white;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 15px;\n}\n\n.tab:hover {\n  background: rgba(255,255,255,0.3);\n  transform: translateY(-2px);\n}\n\n.tab.active {\n  background: rgba(255,255,255,0.9);\n  color: #667eea;\n  border-color: white;\n}\n\n/* Messages */\n.message {\n  padding: 15px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  text-align: center;\n  font-weight: 500;\n}\n\n.message.success {\n  background: rgba(52, 211, 153, 0.2);\n  color: #34d399;\n  border-left: 4px solid #34d399;\n}\n\n.message.error {\n  background: rgba(239, 68, 68, 0.2);\n  color: #fca5a5;\n  border-left: 4px solid #ef4444;\n}\n\n/* Create Form */\n.create-form {\n  background: rgba(255,255,255,0.1);\n  padding: 25px;\n  border-radius: 12px;\n  backdrop-filter: blur(10px);\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 600;\n  font-size: 15px;\n}\n\n.form-group select,\n.form-group input {\n  width: 100%;\n  padding: 12px;\n  border: 2px solid rgba(255,255,255,0.3);\n  border-radius: 8px;\n  background: rgba(255,255,255,0.95);\n  color: #333;\n  font-size: 14px;\n  transition: border-color 0.3s ease;\n}\n\n.form-group select:focus,\n.form-group input:focus {\n  outline: none;\n  border-color: rgba(255,255,255,0.8);\n  background: white;\n}\n\n.form-group small {\n  display: block;\n  margin-top: 5px;\n  font-size: 12px;\n  opacity: 0.8;\n}\n\n/* Buttons */\n.btn-primary,\n.btn-secondary,\n.btn-large {\n  padding: 12px 24px;\n  border: none;\n  border-radius: 8px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 15px;\n}\n\n.btn-primary {\n  background: linear-gradient(135deg, #34d399 0%, #10b981 100%);\n  color: white;\n  width: 100%;\n  margin-top: 10px;\n}\n\n.btn-primary:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(52, 211, 153, 0.3);\n}\n\n.btn-primary:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.btn-secondary {\n  background: rgba(255,255,255,0.2);\n  color: white;\n  width: 100%;\n  margin-top: 10px;\n}\n\n.btn-secondary:hover:not(:disabled) {\n  background: rgba(255,255,255,0.3);\n  transform: translateY(-2px);\n}\n\n.btn-large {\n  padding: 20px 40px;\n  font-size: 18px;\n  background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%);\n  color: #333;\n  width: 100%;\n  margin: 20px 0;\n}\n\n.btn-large:hover:not(:disabled) {\n  transform: scale(1.05);\n  box-shadow: 0 10px 30px rgba(251, 191, 36, 0.3);\n}\n\n.lucky-action-btn {\n  width: 50%;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.start-spotlight {\n  display: grid;\n  justify-items: center;\n  gap: 8px;\n  max-width: 300px;\n  margin: 14px auto 8px;\n  padding: 12px 14px;\n  text-align: center;\n  border-radius: 14px;\n  border: 1px solid rgba(255,255,255,0.18);\n  background: radial-gradient(circle at top, rgba(251,191,36,0.18), transparent 58%), rgba(255,255,255,0.10);\n  box-shadow: 0 12px 24px rgba(0,0,0,0.18);\n}\n\n.start-spotlight__title {\n  font-size: 15px;\n  font-weight: 800;\n}\n\n.start-spotlight__sub {\n  font-size: 12px;\n  color: rgba(255,255,255,0.82);\n}\n\n.start-spotlight .btn-primary,\n.start-spotlight .btn-large {\n  width: auto;\n  min-width: 170px;\n  margin-top: 0;\n  padding: 9px 16px;\n  font-size: 14px;\n  border-radius: 999px;\n}\n\n@media (max-width: 640px) {\n  .start-spotlight {\n    margin-top: 16px;\n    padding: 10px 12px;\n  }\n}\n\n/* Available Challenges */\n.available-challenges {\n  background: rgba(255,255,255,0.1);\n  padding: 25px;\n  border-radius: 12px;\n  backdrop-filter: blur(10px);\n}\n\n.available-challenges h3 {\n  margin-bottom: 20px;\n  font-size: 18px;\n}\n\n.join-toolbar {\n  display: grid;\n  grid-template-columns: 1.2fr 0.7fr 0.7fr 1fr 1fr auto;\n  gap: 10px;\n  align-items: center;\n  margin: 10px 0 16px;\n}\n\n.toolbar-input,\n.toolbar-select {\n  width: 100%;\n  padding: 10px 12px;\n  border-radius: 10px;\n  border: 1px solid rgba(255,255,255,0.22);\n  background: rgba(255,255,255,0.92);\n  color: #222;\n  font-size: 14px;\n}\n\n.toolbar-input:focus,\n.toolbar-select:focus {\n  outline: none;\n  border-color: rgba(255,255,255,0.55);\n  background: #fff;\n}\n\n@media (max-width: 760px) {\n  .join-toolbar {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n.challenges-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 15px;\n}\n\n/* Compact Join list (scales better than cards) */\n.challenges-compact {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.challenge-row {\n  display: grid;\n  grid-template-columns: 1.2fr 0.8fr 0.8fr 1.2fr;\n  gap: 10px;\n  align-items: center;\n  padding: 12px 12px;\n  border-radius: 10px;\n  background: rgba(0,0,0,0.25);\n  border: 1px solid rgba(255,255,255,0.18);\n}\n\n.challenge-row.header {\n  background: rgba(0,0,0,0.35);\n  border-color: rgba(255,255,255,0.22);\n  font-weight: 700;\n  font-size: 13px;\n}\n\n.challenge-row .cell {\n  font-size: 14px;\n  color: rgba(255,255,255,0.95);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.challenge-row .cell.actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.btn-inline {\n  width: auto;\n  margin-top: 0;\n  padding: 10px 14px;\n  font-size: 14px;\n}\n\n/* Modal */\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 18px;\n  z-index: 9999;\n}\n\n.modal {\n  width: min(520px, 95vw);\n  background: linear-gradient(135deg, rgba(20,20,30,0.95) 0%, rgba(30,20,45,0.95) 100%);\n  border: 1px solid rgba(255,255,255,0.18);\n  border-radius: 14px;\n  color: white;\n  box-shadow: 0 20px 50px rgba(0,0,0,0.35);\n}\n\n.modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 16px;\n  border-bottom: 1px solid rgba(255,255,255,0.12);\n}\n\n.modal-header h3 {\n  margin: 0;\n  font-size: 18px;\n}\n\n.modal-close {\n  background: transparent;\n  border: none;\n  color: rgba(255,255,255,0.9);\n  font-size: 26px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.modal-body {\n  padding: 14px 16px;\n}\n\n.modal-body p {\n  margin: 8px 0;\n  font-size: 14px;\n  color: rgba(255,255,255,0.95);\n}\n\n.modal-footer {\n  padding: 14px 16px;\n  border-top: 1px solid rgba(255,255,255,0.12);\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n@media (max-width: 520px) {\n  .challenge-row {\n    grid-template-columns: 1fr 0.8fr 0.8fr;\n    grid-template-areas:\n      \"creator wager players\"\n      \"actions actions actions\";\n  }\n  .challenge-row .cell.actions {\n    justify-content: flex-start;\n  }\n}\n\n.challenge-card {\n  background: rgba(0,0,0,0.25);\n  border: 2px solid rgba(255,255,255,0.25);\n  border-radius: 10px;\n  padding: 15px;\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n.challenge-card:hover {\n  background: rgba(0,0,0,0.32);\n  border-color: rgba(255,255,255,0.55);\n  transform: translateY(-5px);\n}\n\n.challenge-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 15px;\n}\n\n.challenge-header h4 {\n  margin: 0;\n  font-size: 16px;\n  color: rgba(255, 255, 255, 0.98);\n}\n\n.badge {\n  background: rgba(255,255,255,0.3);\n  padding: 4px 8px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.challenge-details p {\n  margin: 8px 0;\n  font-size: 14px;\n  opacity: 1;\n  color: rgba(255, 255, 255, 0.95);\n}\n\n.challenge-details strong {\n  color: rgba(255, 255, 255, 1);\n}\n\n.challenge-instructions {\n  margin-top: 12px;\n  padding: 10px 12px;\n  background: rgba(0, 0, 0, 0.25);\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  border-radius: 10px;\n}\n\n.challenge-instructions .instruction-line {\n  font-size: 13px;\n  line-height: 1.3;\n  opacity: 1;\n  color: rgba(255, 255, 255, 0.98);\n}\n\n.challenge-instructions .instruction-line + .instruction-line {\n  margin-top: 6px;\n}\n\n.challenge-instructions .instruction-hint {\n  margin-top: 8px;\n  font-size: 12px;\n  line-height: 1.3;\n  color: rgba(255, 255, 255, 0.9);\n}\n\n/* Multiplayer Game */\n.multiplayer-game {\n  max-width: 900px;\n  margin: 20px auto;\n  padding: 20px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-radius: 15px;\n  box-shadow: 0 10px 30px rgba(0,0,0,0.2);\n  color: white;\n  overflow-x: hidden;\n}\n\n.multiplayer-game h2,\n.multiplayer-game h3 {\n  text-align: center;\n  text-shadow: 2px 2px 4px rgba(0,0,0,0.3);\n}\n\n.waiting-state,\n.rolling-state,\n.results-state {\n  background: rgba(255,255,255,0.1);\n  padding: 25px;\n  border-radius: 12px;\n  backdrop-filter: blur(10px);\n}\n\n.player-list {\n  margin: 20px 0;\n  background: rgba(255,255,255,0.1);\n  padding: 15px;\n  border-radius: 8px;\n}\n\n.player-list h4 {\n  margin: 0 0 10px 0;\n  font-size: 15px;\n}\n\n.player-slot {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 0;\n  border-bottom: 1px solid rgba(255,255,255,0.1);\n}\n\n.player-slot:last-child {\n  border-bottom: none;\n}\n\n.player-badges {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.player-name {\n  font-weight: 600;\n}\n\n.player-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 0;\n  border-bottom: 1px solid rgba(255,255,255,0.1);\n}\n\n.player-item:last-child {\n  border-bottom: none;\n}\n\n.lucky-mode {\n  font-weight: 700;\n}\n\n.lucky-mode.betting {\n  color: #fca5a5;\n}\n\n.lucky-mode.friendly {\n  color: #86efac;\n}\n\n.lucky-wager.betting {\n  color: #fca5a5;\n  font-weight: 900;\n}\n\n.lucky-wager.friendly {\n  color: #86efac;\n  font-weight: 900;\n}\n\n.dice-display {\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n  margin: 30px 0;\n  flex-wrap: wrap;\n}\n\n.die {\n  width: 60px;\n  height: 60px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%);\n  border-radius: 8px;\n  font-size: 28px;\n  font-weight: bold;\n  color: #333;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.2);\n}\n\n.die.revealing {\n  animation: die-reveal 0.7s ease-in-out;\n}\n\n@keyframes die-reveal {\n  0% {\n    transform: scale(0.8) rotate(-6deg);\n    opacity: 0.4;\n    filter: blur(2px);\n  }\n  60% {\n    transform: scale(1.05) rotate(4deg);\n    opacity: 0.9;\n    filter: blur(0);\n  }\n  100% {\n    transform: scale(1) rotate(0deg);\n    opacity: 1;\n    filter: blur(0);\n  }\n}\n\n.multiplayer-game canvas {\n  max-width: 100%;\n  height: auto;\n  display: block;\n}\n\n.dice-result {\n  text-align: center;\n}\n\n.dice-result h2 {\n  color: #34d399;\n  font-size: 32px;\n  margin: 20px 0;\n}\n\n.scores-board {\n  margin-top: 25px;\n  background: rgba(255,255,255,0.1);\n  padding: 15px;\n  border-radius: 8px;\n}\n\n.scores-board h4 {\n  margin: 0 0 15px 0;\n  font-size: 15px;\n}\n\n.score-item {\n  display: flex;\n  justify-content: space-between;\n  padding: 10px 0;\n  border-bottom: 1px solid rgba(255,255,255,0.1);\n}\n\n.score-item:last-child {\n  border-bottom: none;\n}\n\n.score-item .score {\n  font-weight: 600;\n  color: #fbbf24;\n}\n\n/* Results */\n.leaderboard {\n  margin: 30px 0;\n  background: rgba(255,255,255,0.1);\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.placement {\n  padding: 15px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid rgba(255,255,255,0.1);\n}\n\n.placement:last-child {\n  border-bottom: none;\n}\n\n.placement.rank-1 {\n  background: rgba(251, 191, 36, 0.2);\n  border-left: 4px solid #fbbf24;\n}\n\n.placement.rank-2 {\n  background: rgba(192, 192, 192, 0.2);\n  border-left: 4px solid #c0c0c0;\n}\n\n.placement.rank-3 {\n  background: rgba(205, 127, 50, 0.2);\n  border-left: 4px solid #cd7f32;\n}\n\n.placement.rank-4 {\n  background: rgba(255,255,255,0.05);\n  border-left: 4px solid rgba(255,255,255,0.3);\n}\n\n.rank {\n  font-weight: 700;\n  font-size: 18px;\n  min-width: 50px;\n}\n\n.prize {\n  font-weight: 600;\n  color: #34d399;\n  font-size: 18px;\n}\n\n.result-summary {\n  text-align: center;\n  padding: 20px;\n  background: rgba(34, 197, 94, 0.1);\n  border-radius: 8px;\n  margin-top: 20px;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .multiplayer-lobby,\n  .multiplayer-game {\n    margin: 10px;\n    padding: 15px;\n  }\n\n  .challenges-list {\n    grid-template-columns: 1fr;\n  }\n\n  .dice-display {\n    gap: 5px;\n  }\n\n  .die {\n    width: 50px;\n    height: 50px;\n    font-size: 22px;\n  }\n\n  .tab {\n    padding: 10px 16px;\n    font-size: 13px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
